// src/theme/theme.js
const theme = {
    colors: {
      primary: '#F69620',     // Primary brand color
      background: '#272727',  // Main background color
      surface: '#333333',     // Surface color for cards, modals, etc.
      textPrimary: '#ffffff', // Primary text color
      textSecondary: '#CCCCCC', // Secondary text (optional)
      error: '#FF5252',       // Error color
      success: '#84c959',
      inputGray: '#787878',
      black: '#000000',
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: {
        small: '0.875rem',    // 14px
        medium: '1rem',       // 16px
        large: '1.25rem',     // 20px
        extraLarge: '2rem',   // 32px
      },
      fontWeight: {
        regular: 400,
        medium: 500,
        bold: 700,
      },
    },
    buttonSizes: {
      small: '8px 16px',
      medium: '12px 24px',   // Default size
      large: '16px 32px',
    },
    spacing: (factor) => `${factor * 8}px`,  // 8px grid system for consistent spacing
    borderRadius: '8px',  // Global border radius for inputs, buttons, etc.
  };
  
  export default theme; 
  